import { trackSimpleEvent } from "../../shared/utils/reduxBeacon";
import { addProduct, removeProduct } from "./actions";

const gaEventsMap = {
  ...trackSimpleEvent(addProduct.type),
  ...trackSimpleEvent(removeProduct.type),
};

export default gaEventsMap;
